import './App.css';
import { useState } from 'react';
import {
  BarChart3,
  Trophy,
  Settings,
  Gift,
  FlaskConical,
  Calendar,
  Music,
} from 'lucide-react';

function App() {
  const [formData, setFormData] = useState({
    userName: '',
    industry: '',
    mobile: '',
    description: ''
  });

  const [message, setMessage] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const mobileRegex = /^1[3-9]\d{9}$/;
    if (!mobileRegex.test(formData.mobile)) {
      showMessage('请输入正确的中国大陆手机号码', 'error');
      return;
    }

    try {
      const response = await fetch('https://api.sanesee.com/add_application', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();
      if (result.code === '0') {
        showMessage('提交成功！我们会尽快与您联系。', 'success');
        setFormData({
          userName: '',
          industry: '',
          mobile: '',
          description: ''
        });
      } else {
        showMessage('提交失败，请稍后重试。', 'error');
      }
    } catch (error) {
      console.error('Error:', error);
      showMessage('提交失败，请检查网络连接后重试。', 'error');
    }
  };

  const showMessage = (text, type) => {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 3000);
  };

  return (
    <div className="App">
      <header className="header">
        <div className="container">
          <div className="logo">
            <div className="logo-icon" aria-hidden="true">
              <Music size={18} />
            </div>
            <h1>申嘻教务</h1>
          </div>
          <nav className="navigation">
            <ul>
              <li><a href="#features">产品优势</a></li>
              <li><a href="#testimonials">客户案例</a></li>
              <li><a href="#contact">联系我们</a></li>
            </ul>
          </nav>
        </div>
      </header>

      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge">十年专注 · 乐器培训教务系统</div>
            <h1>
              专注乐器培训
              <span className="gradient-text">教务系统</span>
              开发十年
            </h1>
            <p className="subtitle">
              为大中型培训机构提供专业教务管理解决方案，提升效率、降低成本，让管理更智能
            </p>
            <div className="cta-buttons">
              <a href="#contact" className="btn primary">免费试用 3 个月</a>
              <a href="#features" className="btn secondary">了解优势</a>
            </div>
            <div className="hero-stats">
              <div className="hero-stat">
                <span className="hero-stat-value">2000+</span>
                <span className="hero-stat-label">合作机构</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-value">10+ 年</span>
                <span className="hero-stat-label">行业经验</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-value">300+</span>
                <span className="hero-stat-label">帮机构节省人天/月</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features" id="features">
        <div className="container">
          <h2 className="section-title">为什么选择申嘻教务系统？</h2>
          <p className="section-subtitle">
            从效率、品牌、定制到服务，为培训机构提供一站式教务管理能力
          </p>
          <div className="feature-grid">
            <div className="feature-card">
              <div className="feature-icon-wrap">
                <BarChart3 size={24} strokeWidth={2} />
              </div>
              <h3>显著提升工作效率</h3>
              <p>每月最高可为大型连锁机构节省 300 人天以上的统计工作量，相当于每月可少开 10 个人的工资</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrap">
                <Trophy size={24} strokeWidth={2} />
              </div>
              <h3>行业领先品牌</h3>
              <p>超过 2000 个知名连锁乐器培训机构的选择，品质值得信赖</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrap">
                <Settings size={24} strokeWidth={2} />
              </div>
              <h3>专属定制开发</h3>
              <p>针对大中型培训机构提供免费定制开发服务，满足个性化需求</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrap">
                <Gift size={24} strokeWidth={2} />
              </div>
              <h3>超值优惠活动</h3>
              <p>新客户可享受购买 2 年送 1 年、购买 3 年送 2 年优惠活动</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrap">
                <FlaskConical size={24} strokeWidth={2} />
              </div>
              <h3>免费试用保障</h3>
              <p>新客户免费试用 3 个月，试用满意后再付费，零风险体验</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrap">
                <Calendar size={24} strokeWidth={2} />
              </div>
              <h3>十年专业经验</h3>
              <p>申嘻教务团队专注于乐器培训教务系统开发十年，深谙行业需求</p>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials" id="testimonials">
        <div className="container">
          <h2 className="section-title">客户评价</h2>
          <p className="section-subtitle">
            来自连锁机构负责人与运营团队的真实反馈
          </p>
          <div className="testimonial-grid">
            <div className="testimonial-card">
              <p>「使用申嘻教务系统后，我们机构的人力成本降低了 20%，统计工作几乎实现了自动化。」</p>
              <div className="client">— 某知名钢琴连锁机构 CEO</div>
            </div>
            <div className="testimonial-card">
              <p>「定制开发服务非常贴心，完全贴合我们机构的实际运营流程，大大提升了管理效率。」</p>
              <div className="client">— 某大型音乐培训集团 运营总监</div>
            </div>
            <div className="testimonial-card">
              <p>「十年的专业经验果然不是吹的，系统的稳定性和功能全面性远超同类产品。」</p>
              <div className="client">— 某吉他教育连锁 创始人</div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact" id="contact">
        <div className="container">
          <h2 className="section-title">联系我们</h2>
          <p className="section-subtitle">
            填写表单，24 小时内获得专属顾问联系与产品演示
          </p>
          <div className="contact-content">
            <div className="contact-info">
              <h3>获取免费试用</h3>
              <p>填写右侧表单，我们的专业顾问将在 24 小时内联系您，为您安排免费产品演示。</p>
            </div>
            <div className="contact-form">
              {message && (
                <div className={`message ${message.type}`} role="alert">
                  {message.text}
                </div>
              )}
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <input
                    type="text"
                    name="userName"
                    placeholder="您的姓名"
                    required
                    value={formData.userName}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="tel"
                    name="mobile"
                    placeholder="联系电话"
                    required
                    value={formData.mobile}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    name="description"
                    placeholder="您的机构名称"
                    required
                    value={formData.description}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <select
                    id="industry"
                    name="industry"
                    required
                    value={formData.industry}
                    onChange={handleInputChange}
                  >
                    <option value="">请选择机构类型</option>
                    <option value="0">乐器培训</option>
                    <option value="1">美术培训</option>
                    <option value="2">棋类培训</option>
                    <option value="3">舞蹈培训</option>
                    <option value="4">其他培训</option>
                  </select>
                </div>
                <button type="submit" className="btn primary">提交信息</button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>申嘻教务系统</h3>
              <p>专注乐器培训教务系统开发十年，为培训机构提供高效、稳定的管理解决方案。</p>
            </div>
            <div className="footer-section">
              <h4>快速链接</h4>
              <ul>
                <li><a href="#features">产品优势</a></li>
                <li><a href="#testimonials">客户案例</a></li>
                <li><a href="#contact">联系我们</a></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>© {new Date().getFullYear()} 申嘻教务系统. 保留所有权利.</p>
            <p className="footer-icp">
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">粤ICP备19098413号-2</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
